var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.639648,
    y: 0.574219,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#4770DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5396 13.3197C25.8314 13.3197 26.1112 13.4356 26.3175 13.6419C26.5238 13.8482 26.6396 14.1279 26.6396 14.4197C26.6396 14.7114 26.5238 14.9912 26.3175 15.1975C26.1112 15.4038 25.8314 15.5197 25.5396 15.5197H20.6226L20.4796 16.8507L18.0596 22.2847C17.8396 22.8347 17.2566 23.2197 16.5856 23.2197H11.7896C10.9096 23.2197 10.1396 22.4167 10.1396 21.5697V14.4197C10.1396 13.9907 10.3156 13.6057 10.6126 13.3197L15.2326 7.92969L16.0796 8.74369C16.2996 8.95269 16.4316 9.23869 16.4316 9.55769L16.3986 9.79969L14.5396 13.3197H25.5396ZM4.63965 23.2197V14.4197H7.93965V23.2197H4.63965Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon19);
export default __webpack_public_path__ + "static/media/icon19.34eabe5ad2186b925fcf63976d9de21a.svg";
export { ForwardRef as ReactComponent };